import React from "react";
import { CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";

export default function MemberExportModal({ open, message }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth aria-labelledby="member-export-title">
      <DialogContent className="py-10 px-8 text-center">
        <CircularProgress size={40} thickness={4} className="!text-gx-navy mx-auto" />
        <Typography id="member-export-title" className="!mt-6 !font-semibold !text-gx-ink" variant="h6">
          Preparing your download
        </Typography>
        <Typography className="!mt-2 !text-sm !text-gx-ink-soft" variant="body2">
          {message || "We are building your spreadsheet. Large rosters can take a minute — please keep this tab open."}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
